import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "flex gap-[20px] w-full"
};
const _hoisted_2 = {
  class: "relative mb-[10px]"
};
const _hoisted_3 = {
  class: "absolute bottom-[10px] right-[10px] text-gray-400 text-[12px]"
};
const _hoisted_4 = {
  class: "flex items-center mb-[10px]"
};
const _hoisted_5 = {
  class: "flex items-center mb-[15px]"
};
const _hoisted_6 = {
  class: "flex justify-end"
};
const _hoisted_7 = {
  key: 1,
  class: "font-bold mb-[15px]"
};
const _hoisted_8 = {
  class: "flex justify-between text-[12px] text-gray-500 mb-[5px]"
};
const _hoisted_9 = {
  class: "px-[8px] py-[4px] bg-blue-50 text-blue-500 rounded-full text-[12px] font-bold"
};
const _hoisted_10 = {
  class: "flex justify-between items-center"
};
const _hoisted_11 = {
  class: "flex items-center text-gray-500 text-[13px]"
};
import { useMessage } from '@/hooks/web/useMessage';
import { KnowledgeSegmentApi } from '@/api/ai/knowledge/segment';
import { KnowledgeApi } from '@/api/ai/knowledge/knowledge';
import { useRoute, useRouter } from 'vue-router';
import { reactive, onMounted, ref } from 'vue';
/** 文档召回测试 */
export default /*@__PURE__*/_defineComponent({
  ...{
    name: 'KnowledgeDocumentRetrieval'
  },
  __name: 'index',
  props: {
    knowledgeId: {}
  },
  setup(__props) {
    const props = __props;
    const message = useMessage(); // 消息弹窗
    const route = useRoute(); // 路由
    const router = useRouter(); // 路由
    const loading = ref(false); // 加载状态
    const segments = ref([]); // 召回结果
    const queryParams = reactive({
      id: undefined,
      content: '',
      topK: 10,
      similarityThreshold: 0.5
    });
    /** 调用文档召回测试接口 */
    const getRetrievalResult = async () => {
      if (!queryParams.content) {
        message.warning('请输入查询文本');
        return;
      }
      loading.value = true;
      segments.value = [];
      try {
        const data = await KnowledgeSegmentApi.searchKnowledgeSegment({
          knowledgeId: queryParams.id,
          content: queryParams.content,
          topK: queryParams.topK,
          similarityThreshold: queryParams.similarityThreshold
        });
        segments.value = data || [];
      } catch (error) {
        console.error(error);
      } finally {
        loading.value = false;
      }
    };
    /** 展开/收起段落内容 */
    const toggleExpand = segment => {
      segment.expanded = !segment.expanded;
    };
    /** 获取知识库信息 */
    const getKnowledgeInfo = async id => {
      try {
        const knowledge = await KnowledgeApi.getKnowledge(id);
        if (knowledge) {
          queryParams.topK = knowledge.topK || queryParams.topK;
          queryParams.similarityThreshold = knowledge.similarityThreshold || queryParams.similarityThreshold;
        }
      } catch (error) {}
    };
    /** 初始化 **/
    onMounted(() => {
      // 如果知识库 ID 不存在，显示错误提示并关闭页面
      // if (!route.query.id) {
      //   message.error('知识库 ID 不存在，无法进行召回测试')
      //   router.back()
      //   return
      // }
      // queryParams.id = route.query.id as any
      queryParams.id = props.knowledgeId;
      // 获取知识库信息并设置默认值
      getKnowledgeInfo(queryParams.id);
    });
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_input_number = _resolveComponent("el-input-number");
      const _component_el_button = _resolveComponent("el-button");
      const _component_ContentWrap = _resolveComponent("ContentWrap");
      const _component_el_empty = _resolveComponent("el-empty");
      const _component_Icon = _resolveComponent("Icon");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_ContentWrap, {
        class: "flex-1 mt-[60px] min-w-[300px]"
      }, {
        default: _withCtx(() => [_cache[6] || (_cache[6] = _createElementVNode("div", {
          class: "mb-[15px]"
        }, [_createElementVNode("h3", {
          class: "m-0 mb-[5px]"
        }, "召回测试"), _createElementVNode("div", {
          class: "text-gray-500 text-[14px]"
        }, "根据给定的查询文本测试召回效果。")], -1)), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_input, {
          modelValue: queryParams.content,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => queryParams.content = $event),
          type: "textarea",
          rows: 8,
          placeholder: "请输入文本"
        }, null, 8, ["modelValue"]), _createElementVNode("div", _hoisted_3, _toDisplayString(queryParams.content?.length) + " / 200 ", 1)]), _createElementVNode("div", _hoisted_4, [_cache[3] || (_cache[3] = _createElementVNode("span", {
          class: "w-[60px] text-gray-500"
        }, "topK:", -1)), _createVNode(_component_el_input_number, {
          modelValue: queryParams.topK,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => queryParams.topK = $event),
          min: 1,
          max: 20
        }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_5, [_cache[4] || (_cache[4] = _createElementVNode("span", {
          class: "w-[60px] text-gray-500"
        }, "相似度:", -1)), _createVNode(_component_el_input_number, {
          modelValue: queryParams.similarityThreshold,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => queryParams.similarityThreshold = $event),
          min: 0,
          max: 1,
          precision: 2,
          step: 0.01
        }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: getRetrievalResult,
          loading: loading.value
        }, {
          default: _withCtx(() => _cache[5] || (_cache[5] = [_createTextVNode("测试")])),
          _: 1
        }, 8, ["loading"])])])]),
        _: 1
      }), _createVNode(_component_ContentWrap, {
        class: "flex-1 min-w-[300px]"
      }, {
        default: _withCtx(() => [loading.value ? (_openBlock(), _createBlock(_component_el_empty, {
          key: 0,
          description: "正在检索中..."
        })) : segments.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(segments.value.length) + " 个召回段落 ", 1)) : (_openBlock(), _createBlock(_component_el_empty, {
          key: 2,
          description: "暂无召回结果"
        })), _createElementVNode("div", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(segments.value, (segment, index) => {
          return _openBlock(), _createElementBlock("div", {
            key: index,
            class: "mb-[20px] border border-solid border-gray-200 rounded p-[15px]"
          }, [_createElementVNode("div", _hoisted_8, [_createElementVNode("span", null, " 分段(" + _toDisplayString(segment.id) + ") · " + _toDisplayString(segment.contentLength) + " 字符数 · " + _toDisplayString(segment.tokens) + " Token ", 1), _createElementVNode("span", _hoisted_9, " score: " + _toDisplayString(segment.score), 1)]), _createElementVNode("div", {
            class: _normalizeClass(["bg-gray-50 p-[10px] rounded mb-[10px] whitespace-pre-wrap overflow-hidden transition-all duration-100 text-[13px]", {
              'line-clamp-2 max-h-[50px]': !segment.expanded,
              'max-h-500px': segment.expanded
            }])
          }, _toDisplayString(segment.content), 3), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createVNode(_component_Icon, {
            icon: "ep:document",
            class: "mr-[5px]"
          }), _createElementVNode("span", null, _toDisplayString(segment.documentName || '未知文档'), 1)]), _createVNode(_component_el_button, {
            size: "small",
            onClick: $event => toggleExpand(segment)
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(segment.expanded ? '收起' : '展开') + " ", 1), _createVNode(_component_Icon, {
              icon: segment.expanded ? 'ep:arrow-up' : 'ep:arrow-down'
            }, null, 8, ["icon"])]),
            _: 2
          }, 1032, ["onClick"])])]);
        }), 128))])]),
        _: 1
      })]);
    };
  }
});